<template>
  <div>
    <v-row>
      <v-col>
        <v-container pb-4 grid-list-xl>
          <v-layout row wrap class="user-detailboxmain fixed-depositbox">
            <v-flex class="user-detailbox equityListbox bond-equitybox">
              <v-list-item
                v-for="reccuringDetails in savingAccountData"
                :key="reccuringDetails.id"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <h3 v-if="reccuringDetails.name">
                      {{ reccuringDetails.name }}
                    </h3>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-for="savingAccountDatas in reccuringDetails.description"
                    :key="savingAccountDatas.id"
                  >
                    <div class="edit-box">
                      <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined
                              fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide(savingAccountDatas['form_id'])"
                              v-if="allow_user_activity == 'yes'"
                            >
                              <v-img
                                max-height="20"
                                max-width="20"
                                :src="three_dots"
                                :lazy-src="three_dots"
                              ></v-img>
                            </v-btn>
                          </template>
                          <v-list
                            v-if="hideShowId == savingAccountDatas['form_id']"
                          >
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn
                                  @click="
                                    editAccounts(savingAccountDatas['form_id'])
                                  "
                                >
                                  <v-img
                                    max-height="20"
                                    max-width="20"
                                    :src="edit_pic"
                                    :lazy-src="edit_pic"
                                  ></v-img>
                                  Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn
                                  @click="
                                    deleteAccounts(
                                      savingAccountDatas['form_id']
                                    )
                                  "
                                >
                                  <v-img
                                    max-height="23"
                                    max-width="19"
                                    :src="delete_pic"
                                    :lazy-src="delete_pic"
                                  >
                                  </v-img
                                  >Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn @click="updateBond(savingAccountDatas)">
                                  <v-img
                                    max-height="23"
                                    max-width="19"
                                    :src="update_pic"
                                    :lazy-src="update_pic"
                                  >
                                  </v-img
                                  >Update Quantity
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </div>
                    <div class="account-detailbox">
                      <div class="bank-name">
                        <h5 v-if="savingAccountDatas.bond">
                          {{ savingAccountDatas.bond }}
                        </h5>
                        <h5 v-else>Bank name is unavailable</h5>
                        <p v-if="savingAccountDatas.account_no">
                          {{ savingAccountDatas.account_no }}
                        </p>
                      </div>
                      <div class="amount-box">
                        <span>Face Value</span>
                        <p>
                          <span> &#8377;</span>
                          {{ savingAccountDatas.face_value }}
                        </p>
                      </div>
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Quantity</span>
                        <p v-if="savingAccountDatas.no_of_bond">
                          {{ savingAccountDatas.no_of_bond }}
                        </p>
                        <p v-else>Quantity is unavilable</p>
                      </div>
                      <div class="amount-box">
                        <span
                          >Price on
                          {{
                            savingAccountDatas.market_price_updated_date
                          }}</span
                        >
                        <p>
                          <span> &#8377;</span>
                          {{ savingAccountDatas.market_price }}
                        </p>
                      </div>
                    </div>
                    <div class="maturity-Datebox Rate-of-Interest">
                      <div class="bank-name">
                        <span>Coupon Rate</span>
                        <p v-if="savingAccountDatas.coupon_rate">
                          {{ savingAccountDatas.coupon_rate }}%
                        </p>
                        <p v-else>Coupon rate is anavailable</p>
                      </div>
                      <div class="amount-box">
                        <span>
                          Value on {{ currentDate | moment("DD MMM, Y") }}
                        </span>
                        <p>
                          <span> &#8377;</span>
                          {{
                            formatNumber(savingAccountDatas.market_price *
                            savingAccountDatas.no_of_bond)
                          }}

                        </p>
                      </div>
                    </div>
                    <div class="maturity-Datebox Rate-of-Interest">
                      <div class="bank-name">
                        <span>Maturity Date</span>
                        <p v-if="savingAccountDatas.maturity_date">
                          {{
                            savingAccountDatas.maturity_date
                              | moment("DD MMM, Y")
                          }}
                        </p>
                        <p v-else>Maturity date is anavailable</p>
                      </div>
                      <div class="amount-box">
                        <span>Exchange</span>
                        <p>{{ savingAccountDatas.exchange }}</p>
                      </div>
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Credit Rating</span>
                        <p v-if="savingAccountDatas.credit_rating">
                          {{ savingAccountDatas.credit_rating }}
                        </p>
                        <p v-else>N/A</p>
                      </div>
                      <div class="amount-box">
                        <span>Bond Type</span>
                        <p>{{ savingAccountDatas.bond_type }}</p>
                      </div>
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">
                        <label>Investment Goal</label>   
                        <v-select
                          name="cap"
                          :v-model="cap"
                          :items="capList"
                          item-value="type"
                          item-text="name"
                          @change="updatFormCap(savingAccountDatas['form_id'], $event)"
                          bg-color="red"
                          placeholder="Please select your options"
                          class="inline select-box"
                          :value="savingAccountDatas['saving_type']"
                          outlined
                          style="width:400px; border-width:2px;"
                        ></v-select>
                      </div>
                  </div>
                    
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-container>
        <div class="total-amount-box" v-if="savingAccountData.length != 0">
          <h4>Total Bond Valuation</h4>
          <div class="total-amount">
            <span>As on {{ currentDate | moment("DD MMM, Y") }}</span>
            <p><span> &#8377;</span> {{ amount.toLocaleString() }}</p>
          </div>
        </div>
        <div v-else>
          <v-list-item>
            <div class="user-detailbox">
              <v-list-item-content>
                <div class="text-h5 mb-1">No data found.</div>
              </v-list-item-content>
            </div>
          </v-list-item>
        </div>
      </v-col>
    </v-row>
    <modal
      class="common-modal-box small-modal-box my-custom-modal"
      name="update-bond"
    >
      <span class="close">
        <v-img
          width="20"
          height="20"
          @click="close"
          style="float: right"
          :src="require('@/assets/images/cross.png')"
        >
        </v-img>
      </span>
      <v-form ref="update" lazy-validation>
        <v-text-field
          v-model="update_bond"
          value=""
          :rules="[(v) => !!v || 'Field is required']"
          placeholder="Enter Number of Quantity"
          class="balance-field"
        >
        </v-text-field>
        <v-btn class="update-btn" @click="updategoldbold"
          >Update Quantity</v-btn
        >
      </v-form>
    </modal>
  </div>
</template>
<script>
import {
  GET_EQUITIES_AND_BOND_DATA,
  DELETE_EQUITIES_AND_BOND_DATA,
} from "../../store/actions.type";
import { isEmpty } from "lodash";
import axios from "axios";

export default {
  data() {
    return {
      three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
      currentDate: new Date().setDate(new Date().getDate()),
      //amount: 0,
      //savingAccountData: "",
      edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
      delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
      update_pic: process.env.VUE_APP_ROOT_ICONS_URL + "update.png",
      hideShow: false,
      hideShowId: "",
      update_bond: "",
      full_name: "",
      allow_user_activity: localStorage.getItem("allow_user_activity"),
      capList:[{"type":"Saving for Retirement","name":"Saving for Retirement"},{"type":"Saving to fund Children's Education","name":"Saving to fund Children's Education"},{"type":"Saving for a vacation","name":"Saving for a vacation"},{"type":"Buying a home","name":"Buying a home"},{"type":"Starting a business","name":"Starting a business"},{"type":"Building an emergency fund","name":"Building an emergency fund"},{"type":"Paying of debt","name":"Paying of debt"},{"type":"Pre payment of Home Loan","name":"Pre payment of Home Loan"}],
      cap:''
    };
  },
  created() {
    Fire.$on("loadData", () => {
      this.equitiesAndBondList();
    });
  },
  mounted() {
    if (this.isDataEmpty) this.equitiesAndBondList();
  },
  computed: {
    isDataEmpty: function () {
      return isEmpty(this.$store.getters.getEquitiesAndBondData);
    },
    savingAccountData: function () {
      return !this.isDataEmpty
        ? this.$store.getters.getEquitiesAndBondData.data.bond_detail
        : [];
    },
    amount: function () {
      let amount = 0;
      this.$store.getters.getEquitiesAndBondData.balaces_details.balances.forEach(
        (details) => {
          if (details.acoount_type == "Bonds") {
            amount += parseInt(details.balance);
          }
        }
      );
      return amount;
    },
  },
  methods: {
    close() {
      this.$modal.hide("update-bond");
    },
    showHide(id) {
      this.hideShowId = id;
      this.hideShow = !this.hideShow;
    },
    editAccounts(editId) {
      this.$router.push({ path: "/edit-bond/" + btoa(editId) }).catch(() => {});
    },
    updateBond(savingData) {
      this.$modal.show("update-bond");
      this.form_id = savingData.form_id;
    },
    updategoldbold() {
      if (this.$refs.update.validate()) {
        console.log(this.form_id, this.update_bond);
        let formdata = new FormData();
        formdata.append(
          "aws_cognito_id",
          atob(localStorage.getItem("cognito_idp"))
        );
        formdata.append("form_id", this.form_id);
        formdata.append("quantity", this.update_bond);
        formdata.append("module_type", "bond");
        axios
          .post(process.env.VUE_APP_ROOT_API + "update-quantity", formdata)
          .then((res) => {
            this.$modal.hide("update-bond");
            swal.fire({
              title: "Quantity Updated Successfully",
              icon: "success",
            });
            this.equitiesAndBondList();
          })
          .catch(() => {});
      }
    },
    deleteAccounts(id) {
      swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem("cognito_idp"));

            this.$store
              .dispatch(DELETE_EQUITIES_AND_BOND_DATA, {
                data: {
                  aws_cognito_id: cognito_idp,
                  form_id: id,
                },
                api: "delete-form",
              })
              .then(() => {
                this.equitiesAndBondList();
                // Fire.$emit('equitiesData');

                Toast.fire({
                  icon: "success",
                  title: "Data deleted successfully.",
                });
              });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    equitiesAndBondList() {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      this.$store
        .dispatch(GET_EQUITIES_AND_BOND_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id: selected_value,
          },
          api: "get-user-equity-bond-form-detail",
        })
        .then((response) => {
          /*this.savingAccountData = response.data.equity_detail;
                      this.amount = 0;
                        this.savingAccountData.forEach(details => {
                          return this.amount =  parseFloat(details.total_balance);
                        })*/
          Fire.$emit("equitiesData");
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
    },

    formatNumber (num) {
      return parseFloat(num).toFixed(2)
    },

    updatFormCap(id, saving_type){
        let formdata = new FormData();
        formdata.append("form_id", id);
        formdata.append("saving_type", saving_type);
        axios
          .post(process.env.VUE_APP_ROOT_API + "update-user-form-saving-type", formdata)
          .then((res) => {
            // swal.fire({
            //   title: "Saving Type Updated Successfully",
            //   icon: "success",
            // });
          })
          .catch(() => {});
      }
  },
};
</script>
